class MainHeader {
	notificationBar: HTMLDivElement | null;
	header: HTMLDivElement | null;
	adminBar: HTMLElement | null;
	mainNavToggle: HTMLElement | null;
	subnavToggles: NodeListOf<HTMLElement>;
	specificSubnavToggles: NodeListOf<HTMLElement>;
	subnavs: NodeListOf<HTMLElement>;
	subnavButtons: NodeListOf<HTMLElement>;
	deepSubnavButtons: NodeListOf<HTMLElement>;
	deepSubnavs: NodeListOf<HTMLElement>;
	replaceText: HTMLElement | null;
	headerHeightFull: number;

	constructor() {
		this.notificationBar = document.querySelector('.notification-bar');
		this.header = document.querySelector('.main-header');
		this.adminBar = document.getElementById('wpadminbar');
		this.mainNavToggle = document.querySelector('.main-header__mobile-nav-toggle');
		this.subnavToggles = document.querySelectorAll('.main-header__subnav-toggle');
		this.headerHeightFull = 0;
		this.specificSubnavToggles = document.querySelectorAll(
			'.main-header__specific-subnav-toggle'
		);
		this.subnavs = document.querySelectorAll('.primary-nav__sub-nav');
		this.subnavButtons = document.querySelectorAll(
			'.primary-nav__nav-link + .primary-nav__nav-button'
		);
		this.deepSubnavButtons = document.querySelectorAll(
			'.primary-nav__sub-nav .primary-nav__nav-link + .primary-nav__nav-button'
		);
		this.deepSubnavs = document.querySelectorAll(
			'.primary-nav__sub-nav .primary-nav__sub-nav, .primary-nav__sub-nav .primary-nav__nav-link + .primary-nav__nav-button'
		);
		this.replaceText = document.querySelector('.main-header__specific-subnav-toggle > span');
	}

	init() {
		this.setNotificationBarHeight();
		this.setHeaderHeight();
		this.setupToggles();
		this.titleSubnavs();
		this.setSubmenuDirections();
	}

	resized() {
		this.setNotificationBarHeight();
		this.setHeaderHeight();
	}

	loaded() {
		this.setNotificationBarHeight();
		this.setHeaderHeight();
	}

	setNotificationBarHeight() {
		if (!this.notificationBar) return;

		const notificationBarHeight = this.notificationBar.offsetHeight;

		document.documentElement.style.setProperty(
			'--notificationBarHeight',
			notificationBarHeight + 'px'
		);
	}

	setHeaderHeight() {
		if (!this.header) return;

		const headerHeight = this.header.offsetHeight;
		this.headerHeightFull = this.header.offsetHeight;

		if (null !== this.adminBar) {
			this.headerHeightFull += this.adminBar.offsetHeight;
		}

		document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
		document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px');
		document.documentElement.style.setProperty(
			'--headerHeightFull',
			this.headerHeightFull + 'px'
		);
	}

	setHeaderBottomPosition() {
		if (!this.header) return;

		const headerClientRect = this.header.getBoundingClientRect();
		const headerBottomPosition = headerClientRect.top + headerClientRect.height;

		document.documentElement.style.setProperty(
			'--headerBottomPosition',
			headerBottomPosition + 'px'
		);
	}

	setupToggles() {
		this.mainNavToggle?.addEventListener('click', (e) => {
			let srLabel = '';
			const srElement = this.mainNavToggle?.querySelector(':scope > .sr-only');
			this.setHeaderBottomPosition();

			if ('true' === this.mainNavToggle?.getAttribute('aria-expanded')) {
				srLabel = 'Open Toggle Menu';
			}
			if ('false' === this.mainNavToggle?.getAttribute('aria-expanded')) {
				srLabel = 'Close Toggle Menu';
			}

			this.mainNavToggle?.setAttribute('aria-label', srLabel);
			if (srElement) {
				srElement.textContent = srLabel;
			}

			if (this.mainNavToggle?.getAttribute('aria-expanded')) {
				this.subnavs.forEach((el) => {
					el.setAttribute('aria-expanded', 'false');
				});
				this.subnavButtons.forEach((el) => {
					el.setAttribute('aria-expanded', 'false');
				});
			}
		});

		this.subnavToggles.forEach((elToggle) => {
			elToggle.addEventListener('click', (e) => {
				this.subnavs.forEach((el) => {
					el.setAttribute('aria-expanded', 'false');
				});
				this.subnavButtons.forEach((el) => {
					el.setAttribute('aria-expanded', 'false');
				});
			});
		});

		this.specificSubnavToggles.forEach((elToggle) => {
			elToggle.addEventListener('click', (e) => {
				this.deepSubnavs.forEach((el) => {
					el.setAttribute('aria-expanded', 'false');
				});
			});
		});

		this.deepSubnavButtons.forEach((elToggle) => {
			elToggle.addEventListener('click', (e) => {
				if (this.replaceText) {
					this.replaceText.textContent = 'Back to ' + elToggle.textContent;
				}
			});
		});
	}

	titleSubnavs() {
		this.subnavs.forEach((el) => {
			const parentLink = el.closest('li')?.querySelector('.primary-nav__nav-link');
			if (parentLink) {
				const prependHTML =
					'<li class="primary-nav__parent-item">' + parentLink.outerHTML + '</li>';
				el.insertAdjacentHTML('afterbegin', prependHTML);
			}
		});
	}

	setSubmenuDirections() {
		const submenus = document.querySelectorAll<HTMLElement>(
			'.primary-nav__sub-nav .primary-nav__sub-nav'
		);

		submenus.forEach((el) => {
			const parentElement = el.parentElement; // Get the direct parent

			// Store original styles
			const originalVisibility = el.style.visibility;
			const originalDisplay = el.style.display;
			const originalPosition = el.style.position;

			// Temporarily make visible but off-screen for measurement
			el.style.visibility = 'hidden';
			el.style.display = 'block';
			el.style.position = 'absolute';

			// Restore original styles
			el.style.visibility = originalVisibility;
			el.style.display = originalDisplay;
			el.style.position = originalPosition;

			if (parentElement) {
				// Find direct child <a> elements within the parent
				const parentMenuLink = parentElement?.querySelector<HTMLAnchorElement>('a');

				parentMenuLink?.addEventListener('mouseenter', () => {
					const elHeight = el.clientHeight;

					// Get submenu position and dimensions
					const submenuRect = el.getBoundingClientRect();
					const submenuBottom = submenuRect.top + elHeight + this.headerHeightFull;
					const windowHeight = window.innerHeight;

					// Check if submenu extends beyond window height
					if (submenuBottom > windowHeight) {
						el.classList.add('use-bottom-position');
					} else {
						el.classList.remove('use-bottom-position');
					}
				});

				parentMenuLink?.addEventListener('mouseleave', () => {
					el.classList.remove('use-bottom-position');
				});
			}
		});
	}
}

export default new MainHeader();
